import { createApp as createVueApp, CreateAppFunction, Plugin } from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import vClickOutside from 'click-outside-vue3'

import domPurifyConfig from '@app/shared/config/dom-purify'
import getPiniaInstance from '@app/shared/pinia/instance'
import TooltipDirective from '@app/shared/vue/directives/tooltip'
import AutoResizeDirective from '@app/shared/vue/directives/autoresize.js'
import FocusDirective from '@app/shared/vue/directives/focus'
import MentionableDirective from '@app/shared/vue/directives/mentionable.js'
import { HighlightUpdatesPlugin } from '@app/shared/vue/plugins/flash-updates'
import I18nPlugin from '@app/shared/vue/plugins/i18n.js'
import ImagesRequirePlugin from '@app/shared/vue/plugins/images-require.js'
import TurbolinksPlugin from '@app/shared/vue/plugins/turbolinks'
import environment from '@app/utils/environment'

export const createApp: CreateAppFunction<Element> = (Component, props) => {
  const app = createVueApp(Component, props)
  const pinia = getPiniaInstance()

  app.directive('autoresize', AutoResizeDirective)
  app.directive('focus', FocusDirective)
  app.directive('mentionable', MentionableDirective)

  if (environment.__DEV__) {
    app.use(HighlightUpdatesPlugin)
  }

  app.use(I18nPlugin)
  app.use(ImagesRequirePlugin as Plugin)
  app.directive('tooltip', TooltipDirective)
  app.use(VueDOMPurifyHTML, {
    default: domPurifyConfig,
    namedConfigurations: {
      review: {
        ...domPurifyConfig,
        ADD_ATTR: ['onclick'], // in WF review, we bind some server-side rendered HTML with the onclick used for an XHR modal
      },
    },
  })
  app.use(TurbolinksPlugin)
  app.use(pinia)
  app.use(vClickOutside)

  return app
}
